import React from 'react';
import { IconCheck, IconGripVertical } from '@tabler/icons-react';

// Toggle button for entering/exiting the drag-and-drop priority reorder mode.
export default function PriorityToggleButton({ active, saving, onClick, activeLabel, inactiveLabel, savingLabel = 'Ukládám…' }) {
  return (
    <button
      type="button"
      className={`btn flex-shrink-0${active ? ' btn-primary' : ' btn-outline-secondary'}`}
      onClick={onClick}
      disabled={saving}
    >
      {saving && !active
        ? <><span className="spinner-border spinner-border-sm me-1" role="status" />{savingLabel}</>
        : active
          ? <><IconCheck size={14} className="me-1" style={{ verticalAlign: '-2px' }} />{activeLabel}</>
          : <><IconGripVertical size={14} className="me-1" style={{ verticalAlign: '-2px' }} />{inactiveLabel}</>}
    </button>
  );
}
